import { gql } from '@apollo/client';

export interface ReportLocationIpResult {
  reportLocationIp: number;
}

export const REPORT_LOCATION_IP = gql`
  mutation ReportLocationIp($locationName: String!, $latitude: Float, $longitude: Float) {
    reportLocationIp(locationName: $locationName, latitude: $latitude, longitude: $longitude)
  }
`;
